import Fuse from "fuse.js";
import { Game } from "../models/Game";

export interface ISeachResult {
  id: null | string;
  title: string;
  game: null | Game;
}

export class SearchService {
  public static prepareSearchParam(searchParam: string): string {
    return (searchParam || "").toString().toLowerCase().trim();
  }

  public static quickSearch(
    games: Game[] = [],
    searchedTerm: string = ""
  ): ISeachResult[] {
    const searchedTermProcessed = this.prepareSearchParam(searchedTerm);
    if (!searchedTermProcessed) {
      return [];
    }

    const gamesWithSeoName = games.map((g: Game) => {
      if (g.seo_GameName) {
        g.name = g.seo_GameName;
      }
      return g;
    });

    const fuse = this.getFuse(gamesWithSeoName);
    const foundedGames = fuse.search(searchedTermProcessed);

    return foundedGames.map(({item}) => ({
      id: item.slug,
      title: item.name,
      game: item,
    }));
  }

  public static searchGames(games: Game[] = [], searchedTerm: string = "") {
    searchedTerm = this.prepareSearchParam(searchedTerm);

    return games.filter((g: Game) => {
      return (
        this.prepareSearchParam(g.seo_GameName).indexOf(searchedTerm) !== -1
      );
    });
  }
  private static fuse: any = null;

  private static getFuse(games: Game[]) {
    if (!this.fuse) {
      this.fuse = new Fuse(games, { keys: ["name"] });
    }

    return this.fuse;
  }
}
